/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Detail_Score_Anatomy_Card_CaptionInputs */

const en_directory_detail_score_anatomy_card_caption = /** @type {(inputs: Directory_Detail_Score_Anatomy_Card_CaptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} scored dimensions`)
};

const zh_directory_detail_score_anatomy_card_caption = /** @type {(inputs: Directory_Detail_Score_Anatomy_Card_CaptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 个评分维度`)
};

/**
* | output |
* | --- |
* | "{count} scored dimensions" |
*
* @param {Directory_Detail_Score_Anatomy_Card_CaptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_score_anatomy_card_caption = /** @type {((inputs: Directory_Detail_Score_Anatomy_Card_CaptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Score_Anatomy_Card_CaptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_score_anatomy_card_caption(inputs)
	return zh_directory_detail_score_anatomy_card_caption(inputs)
});
export { directory_detail_score_anatomy_card_caption as "directory.detail.score_anatomy_card_caption" }